import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { parseUserActive } from '../../../Utils/parseUserActive';

const GetDsoUsers = {
  name: 'getDsoUsers',
  state: {
    data: [],
    allRecords: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: ['Name', 'Email', 'Role', 'Status'],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      const userData = payload.data.map((item) => {
        const activeBool = parseUserActive(item?.active);
        return {
          id: item.id,
          name: item.name,
          email: item.email,
          role: item.role_id === 3 ? 'User' : 'Other',
          active: activeBool ? 'deactivate' : 'activate',
          isActive: activeBool ? 'Active' : 'Disabled',
        };
      });
      return {
        ...state,
        data: userData,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    async getAllDsoUsers({ page, size, search, sorted_by, sort, active }) {
      try {
        this.getRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/organization/getUsers?org_id=${userInfo.org_id}&size=${size}&page=${page}`;
        if (search && search.trim() !== '') {
          url = url + `&search=${encodeURIComponent(search.trim())}`;
        }
        if (sorted_by) {
          url = url + `&sorted_by=${sorted_by}`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }
        if (active === true) {
          url = `${url}&active=1`;
        } else if (active === false) {
          url = `${url}&active=0`;
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetDsoUsers;
